
export class AdministrationBean {

    uuid?:string;
    infRefName?:string;
    routingType?:string;
    createdBy?:string;
    createdDate?:Date;
    changedBy?:string;
    changedDate?:Date;
    serviceType?:string;
    automaticActivationFlag?:boolean;
    flagString?: string;
    version?:number;
    comment?: string;
    }

 

